import r from "./package.json.mjs";
var e, s;
function t() {
  if (s) return e;
  s = 1;
  return e = class {
    constructor(r) {
      this.sender = r;
    }
    send(e) {
      return e.parameters.agent = "smarty (sdk:javascript@" + r.version + ")", new Promise((r, s) => {
        this.sender.send(e).then(r).catch(s);
      });
    }
  };
}
export { t as __require };